<nav
  [ngClass]="{ 'w-91p rounded-full': siteStore.$bp().sm }"
  class="fixed left-0 sm:!max-w-xl sm:!w-full sm:!min-w-xl shadow bottom-5 p-1 sm:bottom-6 h-16 bg-white/70 z-50 border sm:rounded-full backdrop-blur-xl bottom-bar sm:!overflow-hidden"
>
  <div class="h-full p-0 mx-auto sm:!overflow-hidden max-w-xl relative z-40">
    <!-- Sliding Indicator -->
    <div
      class="sliding-indicator"
      [class.hidden]="activeIndex() === -1"
      [style.transform]="'translateX(' + indicatorStyle().left + 'px)'"
      [style.width.px]="indicatorStyle().width"
    ></div>

    <!-- Grid con solo los 4 nav items -->
    <div class="flex h-full bottom-bar-container">
      <div #navItem class="select-none rounded-l-full flex-1">
        <a
          [routerLink]="['/']"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="active-nav-item"
        >
          <app-home-icon
            [size]="siteStore.$bp().sm ? 26 : 24"
            class="text-gray-400"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!text-primary-600"
          ></app-home-icon>
          <span
            class="text-xs sm:mt-0.5 text-gray-900"
            [style]="{ fontSize: siteStore.$bp().sm ? '12px' : '14px' }"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!text-primary-600"
          >
            Inicio
          </span>
        </a>
      </div>
      <div #navItem class="select-none flex-1" *ngIf="hasAnyExtractionAccess()">
        <a
          [routerLink]="['/payments']"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="active-nav-item"
        >
          <app-operations-icon
            [size]="siteStore.$bp().sm ? 26 : 24"
            class="text-gray-400"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!text-primary-600"
          ></app-operations-icon>
          <span
            class="text-xs sm:mt-0.5 text-gray-900"
            [style]="{ fontSize: siteStore.$bp().sm ? '12px' : '14px' }"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!text-primary-600"
          >
            Solicitudes
          </span>
        </a>
      </div>

      <div #navItem class="select-none flex-1">
        <a
          [routerLink]="['/market']"
          [routerLinkActiveOptions]="{ exact: false }"
          routerLinkActive="active-nav-item"
        >
          <app-market-icon
            [size]="siteStore.$bp().sm ? 26 : 24"
            class="text-gray-400"
            [routerLinkActiveOptions]="{ exact: false }"
            routerLinkActive="!text-primary-600"
          ></app-market-icon>
          <span
            class="text-xs sm:mt-0.5 text-gray-900"
            [style]="{ fontSize: siteStore.$bp().sm ? '12px' : '14px' }"
            [routerLinkActiveOptions]="{ exact: false }"
            routerLinkActive="!text-primary-600"
          >
            Mercado
          </span>
        </a>
      </div>
      <!-- <div
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="sm:bg-primary-50/60 !text-primary-800"
        matRipple
        class="select-none"
      >
        <a [routerLink]="['/cards']">
          <app-card-icon
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!text-primary-800"
            class="text-gray-400"
          ></app-card-icon>
          <span class="text-xs sm:mt-0.5" [style]="{fontSize: siteStore.$bp().sm ? '12px':'16px'}">Tarjeta4</span>
        </a>
      </div> -->

      <div #navItem class="select-none flex-1">
        <a
          [routerLink]="['/beneficiaries']"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="active-nav-item"
        >
          <app-receive-icon
            [size]="siteStore.$bp().sm ? 26 : 24"
            class="text-gray-400"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!text-primary-600"
          ></app-receive-icon>
          <span
            class="text-xs sm:mt-0.5 text-gray-900"
            [style]="{ fontSize: siteStore.$bp().sm ? '12px' : '14px' }"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="!text-primary-600"
          >
            Beneficiarios
          </span>
        </a>
      </div>

      <div #navItem class="select-none rounded-r-full flex-1">
        <a
          [routerLink]="siteStore.isMobile() ? ['/settings'] : ['/settings/profile']"
          [class.active-nav-item]="currentRoute().startsWith('/settings')"
        >
          <app-user-icon
            [size]="siteStore.$bp().sm ? 26 : 24"
            class="text-gray-400"
            [class.!text-primary-600]="currentRoute().startsWith('/settings')"
          ></app-user-icon>
          <span
            class="text-xs sm:mt-0.5 text-gray-900"
            [style]="{ fontSize: siteStore.$bp().sm ? '12px' : '14px' }"
            [class.!text-primary-600]="currentRoute().startsWith('/settings')"
          >
            Ajustes
          </span>
        </a>
      </div>
    </div>
  </div>
</nav>
<div
  class="sm:hidden inset-x-0 bottom-0 flex justify-center bg-gradient-to-t from-white pt-10 z-20 pb-8 pointer-events-none fixed"
></div>
